<script lang="ts">
  export let title: string | undefined = undefined
  export let src: string
</script>

<div>
  <img {src} alt={title} />
  {#if title}
    <h1>{title}</h1>
  {/if}
</div>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  div {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 20em;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;

    @media screen and (max-width: breakpoints.$breakpoint-sm) {
      height: 12em;
    }

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: var(--hero-object-position, center);
      z-index: -1;
    }

    h1 {
      margin-bottom: 1em;
      color: #fff;
    }
  }
</style>
